import { render, staticRenderFns } from "./UiTableReportCommon.vue?vue&type=template&id=16a43fd2&scoped=true&"
import script from "./UiTableReportCommon.vue?vue&type=script&lang=js&"
export * from "./UiTableReportCommon.vue?vue&type=script&lang=js&"
import style0 from "./UiTableReportCommon.vue?vue&type=style&index=0&id=16a43fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a43fd2",
  null
  
)

export default component.exports